import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import echarts from "echarts"
import 'echarts-liquidfill'
import echartswordcloud from 'echarts-wordcloud'
import $ from 'jquery'
import './util/rem'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


Vue.prototype.$echarts = echarts //引入组
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
Vue.prototype.$ = $;

Vue.prototype.$axios = axios

axios.defaults.baseURL="http://117.122.208.146:8991"

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
